import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Icon } from 'semantic-ui-react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase'


class AdminNavBar extends Component {

  render() {

    const { auth, pathname } = this.props

    let menu = null
    !isLoaded(auth)
    ? menu = <Menu secondary></Menu> // Loading state, an html placeholder
    : isEmpty(auth)
      ? menu = (
        menu = <Menu>
          <Link className="menu item" to="/"  >
            <Icon name='paint brush' color='red'/>
          </Link>
          <Link className="menu item" to="/"  >
            You do not belong here
          </Link>
        </Menu>
      )
      : menu = (
        menu = <Menu>
          <Link className="menu item" to="/admin"  >
            <Icon name='paint brush' color='blue'/>
          </Link>
          <Link className="menu item" to="/admin/users/list"  >
            <Icon name='list' color={pathname.includes('users/list') ? 'blue' : 'grey'}/>Users
          </Link>
          <Link className="menu item" to="/admin/users/map"  >
            <Icon name='globe' color={pathname.includes('users/map') ? 'blue' : 'grey'} />Users
          </Link>
          <Link className="menu item" to="/admin/messages/list"  >
            <Icon name='list' color={pathname.includes('messages/list') ? 'blue' : 'grey'}/>Messages
          </Link>
          <Link className="menu item" to="/admin/countries/list"  >
            <Icon name='list' color={pathname.includes('countries/list') ? 'blue' : 'grey'} />Countries
          </Link>
          <Link className="menu item" to="/admin/locations/list"  >
            <Icon name='list' color={pathname.includes('locations/list') ? 'blue' : 'grey'} />Locations
          </Link>
          <Link className="menu item" to="/admin/feed/map"  >
            <Icon name='globe' color={pathname.includes('feed/map') ? 'blue' : 'grey'} />Feed
          </Link>


          <Menu.Menu position='right'>
          <Menu.Item
            name='logout'
            onClick={this.props.firebase.logout}
          />
        </Menu.Menu>
        </Menu>
      )

    return menu

  }
}


export default compose(
  firebaseConnect(),
  connect(({ firebase: { auth } }) => ({ auth }))
)(AdminNavBar)



// WEBPACK FOOTER //
// ./src/components/partials/AdminNavBar.js